import { DefaultAddinsDetailsList } from "./DefaultAddinsList";
import type { M365Acquisition } from "owa-graph-schema";

/**
 * Checks if the given acquisition is a default add-in (e.g., My Templates, Bing maps, etc.)
 * @param acquisition M365Acquisition
 * @returns true if the acquisition is a default add-in
 */
export function isDefaultAddin(acquisition: M365Acquisition): boolean {
    return DefaultAddinsDetailsList.some(defaultAddin => defaultAddin.Id === acquisition.manifestId);
}
